// helpers
import availabilityIsAvailable from "../isAvailable";

/**
 * Retourne vrai si la date est réservable sans conditions.
 * @param {object} param0
 * @param {EnhancedDate} param0.date La date courante.
 * @param {EnhancedDate} param0.beginAt La date de début de séjour ou à défaut la date du jour.
 * @param {EnhancedDate} param0.endAt La date de fin de séjour maximale (uniquement dans le cas de checkout).
 * @param {object} param0.availability Les informations de l'API à propos de la date courante.
 * @param {EnhancedDate} param0.today La date du jour.
 * @param {boolean} checkoutMode Le contexte est la sélection de la date de fin de séjour.
 */
export default function availabilityIsAvailableWithoutConditions({
  date,
  beginAt,
  endAt,
  availability,
  today,
  checkoutMode,
}) {
  if (date.isLessThan(beginAt)) {
    return false;
  }

  return (
    (availabilityIsAvailable({ availability }) ||
      (checkoutMode && date.isEqual(endAt))) &&
    (date.getTime() - today.getTime()) / (1000 * 60 * 60 * 24) >=
      (availability?.minOffsets ?? 0) &&
    (!checkoutMode ||
      (checkoutMode &&
        (date.getTime() - beginAt.getTime()) / (1000 * 60 * 60 * 24) >=
          (availability?.minDuration ?? 0)))
  );
}
